export default "__VITE_ASSET__247fbe9a__"